import React, { createContext, useState } from "react";

const BackBtnContext = React.createContext<{
  show: boolean;
  updateBtnAction: (newFunction: () => void) => void;
  updateBtnStatus: (status: boolean) => void;
  executeBtnAction: () => void;
}>({
  show: false,
  updateBtnAction: () => {},
  updateBtnStatus: () => {},
  executeBtnAction: () => {},
});

interface BackBtnContextProviderProps {}
const BackBtnContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [show, setShow] = useState(false);
  const [functionToExecute, setFunctionToExecute] = useState<() => void>(
    () => {}
  );
  const updateBtnAction = (newFunction: () => void) => {
    setFunctionToExecute(() => newFunction);
  };
  const updateBtnStatus = (status: boolean) => {
    setShow(status);
  };
  const executeBtnAction = () => {
    functionToExecute()
  };

  return (
    <BackBtnContext.Provider
      value={{ show, updateBtnStatus, updateBtnAction, executeBtnAction }}
    >
      {children}
    </BackBtnContext.Provider>
  );
};

export { BackBtnContext, BackBtnContextProvider };
